<div class="br-breadcrumb">
   <ul class="crumb-list">
      <!-- Home (opcionalmente visível) -->
      <li class="crumb home">
         <a class="br-button circle" [href]="first?.url || '#'">
            <span class="sr-only">Página inicial</span>
            <i class="fas fa-home"></i>
         </a>
         <!-- <i class="icon fas" [ngClass]="!isMobile ? '' : 'fa-chevron-right'"> </i> -->
      </li>
      <div class="crumb" *ngIf="isMobile">
         <!-- <i class="icon fas" [ngClass]="!isMobile ? '' : 'fa-chevron-right'">
         </i> -->
         <i class="icon fas fa-chevron-right"></i>
      </div>
      <!-- Menu-Mobil (visível apenas no mobile) -->
      <li
         *ngIf="hasMiddle() && isMobile"
         class="crumb menu-mobil"
         data-toggle="dropdown"
      >
         <button class="br-button circle" (click)="toggleDropdown()">
            <span class="sr-only">Abrir menu</span>
            <i
               class="icon fas"
               [ngClass]="showDropdown ? 'fa-folder-minus' : 'fa-folder-plus'"
            ></i>
         </button>
      </li>

      <!-- Itens intermediários visíveis apenas no desktop -->
      <li
         class="crumb"
         *ngFor="let item of middle"
         [ngClass]="{ 'd-none': isMobile }"
      >
         <i class="icon fas fa-chevron-right"></i>
         <a [href]="item.url || '#'">{{ item.label }}</a>
      </li>

      <!-- Último item (ativo) -->
      <li class="crumb" data-active="active">
         <i class="icon fas fa-chevron-right"></i>
         <span>{{ last.label }}</span>
      </li>
   </ul>

   <!-- Menu dropdown de navegação intermediária -->
   <div class="br-card" *ngIf="showDropdown">
      <div>
         <div class="br-list" *ngFor="let item of middle">
            <a
               class="br-item py-3 col"
               [href]="item.url || '#'"
               (click)="selectItem()"
               >{{ item.label }}
            </a>
         </div>
      </div>
   </div>
</div>
